import type { Event } from '@casetrace/shared';

const HIDDEN_KEYS = new Set(['attachments', 'from', 'to', 'cc', 'bcc', 'participants']);

function isParticipantKey(key: string): boolean {
  return key.startsWith('sender') || key.startsWith('recipient');
}

export function metadataEntriesForDisplay(event: Event): [string, unknown][] {
  return Object.entries(event.metadata).filter(([key]) => {
    if (HIDDEN_KEYS.has(key)) {
      return false;
    }
    return !isParticipantKey(key);
  });
}
